import { message as antdMessage } from 'antd'
import { MessageInstance } from 'antd/es/message/interface'
import useMessage from 'antd/es/message/useMessage'

/** @ts-ignore */
export let message: MessageInstance = antdMessage

export function GlobalMessage() {
  const [messageApi, contextHolder] = useMessage()

  message = messageApi

  return <>{contextHolder}</>
}

export function useGlobalMessage() {
  if (!message) {
    throw new Error('GlobalMessage not mounted on root')
  }
  return message
}
